import { httpClient } from "../http/httpClient"
import { AttachmentsTypeResponse } from "../transactionService/attachmentsType"

export const getAttachmentCrefaz = async (id: string) => {
  const { data } = await httpClient
    .get<AttachmentsTypeResponse>(`/self-hire/transaction/${id}/attachments`)
    .catch((error) => {
      throw error?.response?.data || error
    })

  return data.data
}
